import { render, staticRenderFns } from "./AllCustomerTask.vue?vue&type=template&id=6cc312d3&"
import script from "./AllCustomerTask.vue?vue&type=script&lang=js&"
export * from "./AllCustomerTask.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomerTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports